webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _vue = __webpack_require__(27);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(134);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _vueRouter = __webpack_require__(135);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _routes = __webpack_require__(30);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _store = __webpack_require__(31);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _App = __webpack_require__(112);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	_vue2.default.http.options.emulateJSON = true;
	
	_vue2.default.use(_vueRouter2.default);
	
	var router = new _vueRouter2.default({
	  routes: _routes2.default,
	  mode: 'history',
	  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
	    return savedPosition || { x: 0, y: 0 };
	  }
	});
	
	if (window.localStorage) {
	  if (_store2.default.state.token !== window.localStorage.getItem('token')) {
	    _store2.default.commit('SET_TOKEN', window.localStorage.getItem('token'));
	  }
	}
	
	router.beforeEach(function (to, from, next) {
	  if (to.matched.some(function (record) {
	    return record.meta.requiresAuth;
	  })) {
	    if (!(_store2.default.state.token === null)) {
	      fetch('http://ws.ojssymphonique.net/api/auth?token=' + localStorage.getItem('token')).then(function (response) {
	        if (response.status === 200) {
	          next();
	        } else {
	          next('/login');
	        }
	      });
	    } else {
	      next('/login');
	    }
	  } else {
	    next();
	  }
	});
	
	new _vue2.default({
	  el: '#app',
	  router: router,
	  store: _store2.default,
	  render: function render(h) {
	    return h(_App2.default);
	  }
	});
	
	__webpack_require__(46);
	__webpack_require__(28);
	__webpack_require__(29);
	
	$('ul').tree({ animationSpeed: 200 });
	$('ul').on('expanded.tree', function () {
	  $(this).find('span i').removeClass('fa-angle-right').addClass('fa-angle-down');
	});
	$('ul').on('collapsed.tree', function () {
	  $(this).find('span i').removeClass('fa-angle-down').addClass('fa-angle-right');
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Login = __webpack_require__(114);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _Dashboard = __webpack_require__(113);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _Index = __webpack_require__(118);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _Show = __webpack_require__(119);
	
	var _Show2 = _interopRequireDefault(_Show);
	
	var _Create = __webpack_require__(117);
	
	var _Create2 = _interopRequireDefault(_Create);
	
	var _ = __webpack_require__(116);
	
	var _2 = _interopRequireDefault(_);
	
	var _Register = __webpack_require__(115);
	
	var _Register2 = _interopRequireDefault(_Register);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var routes = [{
	  path: '/login',
	  name: 'login',
	  component: _Login2.default,
	  beforeEnter: function beforeEnter(to, from, next) {
	    document.body.className = 'login-page';
	    next();
	  }
	}, {
	  path: '/register',
	  name: 'register',
	  component: _Register2.default,
	  beforeEnter: function beforeEnter(to, from, next) {
	    document.body.className = 'login-page';
	    next();
	  }
	}, {
	  path: '/',
	  component: _Dashboard2.default,
	  meta: { requiresAuth: true },
	  beforeEnter: function beforeEnter(to, from, next) {
	    document.body.className += ' skin-blue sidebar-mini';
	    next();
	  },
	  activate: function activate() {
	    this.$nextTick(function () {});
	  },
	  children: [{
	    path: '',
	    redirect: '/concerts'
	  }, {
	    path: '/concerts',
	    name: 'dashboard',
	    component: _Index2.default
	  }, {
	    path: '*',
	    name: '404',
	    component: _2.default
	  }, {
	    path: '/concerts/:id',
	    component: _Show2.default,
	    name: 'concerts.show'
	  }, {
	    path: '/concerts/create',
	    component: _Create2.default,
	    name: 'concerts.create'
	  }, {
	    path: '/concerts/:id/edit',
	    component: _Create2.default,
	    name: 'concerts.edit'
	  }]
	}, {
	  path: '*',
	  redirect: '/login'
	}];
	
	exports.default = routes;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(27);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(136);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var state = {
	  token: null
	};
	
	var mutations = {
	  SET_TOKEN: function SET_TOKEN(state, token) {
	    state.token = token;
	  },
	  REMOVE_TOKEN: function REMOVE_TOKEN(state) {
	    state.token = null;
	  }
	};
	
	exports.default = new _vuex2.default.Store({
	  state: state,
	  mutations: mutations
	});

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'App'
	};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Sidebar = __webpack_require__(122);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _Header = __webpack_require__(121);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(120);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Dashboard',
	  components: {
	    'app-sidebar': _Sidebar2.default,
	    'app-header': _Header2.default,
	    'app-footer': _Footer2.default
	  },
	  mounted: function mounted() {
	    $('ul').tree({ animationSpeed: 200 });
	    $('ul').on('expanded.tree', function () {
	      $(this).find('span i').removeClass('fa-angle-right').addClass('fa-angle-down');
	    });
	    $('ul').on('collapsed.tree', function () {
	      $(this).find('span i').removeClass('fa-angle-down').addClass('fa-angle-right');
	    });
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Login',
	  data: function data() {
	    return {
	      credentials: {
	        email: '',
	        password: ''
	      },
	      error: ''
	    };
	  },
	  methods: {
	    login: function login() {
	      var store = this.$store;
	
	      var credentials = {
	        email: this.credentials.email,
	        password: this.credentials.password
	      };
	
	      this.$http.post('http://ws.ojssymphonique.net/api/auth', credentials).then(function (data) {
	        var token = data.body.data.token;
	        store.commit('SET_TOKEN', token);
	
	        if (window.localStorage) {
	          window.localStorage.setItem('token', token);
	        }
	
	        this.$router.push('/concerts');
	      }, function (data) {
	        if (data.status === 422) {
	          this.error = 'Il y a des erreurs sur le formulaire';
	        } else {
	          this.error = data.body.message;
	        }
	      });
	    }
	  },
	  mounted: function mounted() {
	    __webpack_require__(94);
	
	    $('input').iCheck({
	      checkboxClass: 'icheckbox_square-blue',
	      radioClass: 'iradio_square-blue',
	      increaseArea: '20%' });
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Register',
	  data: function data() {
	    return {
	      credentials: {
	        email: '',
	        password: '',
	        confirmPassword: '',
	        firstName: '',
	        lastName: ''
	      },
	      success: '',
	      errors: []
	    };
	  },
	  methods: {
	    register: function register() {
	      var _this = this;
	
	      this.$http.post('http://ws.ojssymphonique.net/api/register', {
	        email: this.credentials.email,
	        password: this.credentials.password,
	        firstname: this.credentials.firstName,
	        lastname: this.credentials.lastName,
	        password_confirmation: this.credentials.confirmPassword
	      }).then(function (response) {
	        if (response.body.success) {
	          _this.success = 'Inscription réussie, merci d\'attendre la validation de l\'administrateur';
	        }
	      }).catch(function (response) {
	        if (response.status === 422) {
	          _this.errors = response.body.errors;
	        }
	      });
	    }
	  }
	};

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'NotFound'
	};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'DashboardCreate',
	  data: function data() {
	    return {
	      addresses: [],
	      organizers: [],
	      concert: {
	        name: '',
	        address: 0,
	        organizer: 0,
	        modes: [],
	        active: false,
	        day: '',
	        hours: 12,
	        minutes: 0,
	        delay: 0,
	        categories: []
	      },
	      tickets: [],
	      address: {
	        name: '',
	        address: '',
	        zipcode: '',
	        city: '',
	        country: 'France'
	      },
	      organizer: {
	        name: '',
	        legalForm: '',
	        siret: '',
	        address: 0
	      },
	      modes: [],
	      categories: [],
	      priceCategory: 0,
	      error: ''
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    if (this.$route.params.id) {
	      this.$http.get('http://ws.ojssymphonique.net/api/concerts/' + this.$route.params.id + '?token=' + localStorage.getItem('token')).then(function (response) {
	        var date = new Date(response.body.concert.event_day);
	        var dateFormat = __webpack_require__(88);
	        _this.concert = {
	          id: response.body.concert.id,
	          name: response.body.concert.name,
	          active: parseInt(response.body.concert.active),
	          address: response.body.concert.address_id,
	          organizer: response.body.concert.organizer_id,
	          delay: response.body.concert.safe_delay,
	          day: dateFormat(date, 'yyyy-mm-dd'),
	          hours: date.getHours(),
	          minutes: date.getMinutes(),
	          modes: response.body.modes,
	          categories: response.body.categories
	        };
	      });
	    }
	
	    this.$http.get('http://ws.ojssymphonique.net/api/categories').then(function (response) {
	      this.categories = response.body;
	    });
	
	    this.$http.get('http://ws.ojssymphonique.net/api/addresses?token=' + localStorage.getItem('token')).then(function (response) {
	      this.addresses = response.body;
	    });
	    this.$http.get('http://ws.ojssymphonique.net/api/organizers?token=' + localStorage.getItem('token')).then(function (response) {
	      this.organizers = response.body;
	    });
	    this.$http.get('http://ws.ojssymphonique.net/api/modes').then(function (response) {
	      this.modes = response.body;
	    });
	  },
	  watch: {
	    '$route': 'init'
	  },
	  methods: {
	    init: function init() {
	      if (!this.$route.params.id) {
	        this.concert = {
	          name: '',
	          address: 0,
	          organizer: 0,
	          modes: [],
	          active: false,
	          day: '',
	          hours: 12,
	          minutes: 0,
	          delay: 0,
	          categories: []
	        };
	      }
	    },
	
	    addAddress: function addAddress() {
	      var _this2 = this;
	
	      var newAddress = {
	        name: this.address.name,
	        address: this.address.address,
	        zipcode: this.address.zipcode,
	        city: this.address.city,
	        country: this.address.country
	      };
	      this.$http.post('http://ws.ojssymphonique.net/api/addresses?token=' + localStorage.getItem('token'), newAddress).then(function (response) {
	        newAddress.id = response.body.id;
	        _this2.addresses.push(newAddress);
	        _this2.concert.address = response.body.id;
	      });
	
	      $('#address-create-modal').modal('hide');
	    },
	    addOrganizer: function addOrganizer() {
	      var _this3 = this;
	
	      var newOrganizer = {
	        name: this.organizer.name,
	        legalForm: this.organizer.legalForm,
	        siret: this.organizer.siret,
	        address: this.organizer.address
	      };
	
	      this.$http.post('http://ws.ojssymphonique.net/api/organizers?token=' + localStorage.getItem('token'), newOrganizer).then(function (response) {
	        newOrganizer.id = response.body.id;
	        _this3.organizers.push(newOrganizer);
	        _this3.concert.organizer = response.body.id;
	      });
	
	      $('#organizer-create-modal').modal('hide');
	    },
	    addConcert: function addConcert() {
	      var _this4 = this;
	
	      try {
	        var checkboxFilled = $('.checkbox-group.required :checkbox:checked').length > 0;
	        if (!checkboxFilled) {
	          throw new Error('Champs non complétés');
	        }
	      } catch (error) {
	        this.error = error.message;
	        return;
	      }
	      var date = new Date(this.concert.day);
	      date.setHours(this.concert.hours);
	      date.setMinutes(this.concert.minutes);
	
	      var data = {
	        name: this.concert.name,
	        event_day: date.toString(),
	        active: this.concert.active ? 1 : 0,
	        safe_delay: this.concert.delay,
	        organizer: this.concert.organizer,
	        address: this.concert.address,
	        modes: this.concert.modes,
	        categories: this.concert.categories
	      };
	
	      if (this.$route.params.id) {
	        this.$http.post('http://ws.ojssymphonique.net/api/concerts/' + this.$route.params.id + '?token=' + localStorage.getItem('token'), data).then(function (response) {
	          _this4.$router.push({ name: 'dashboard' });
	        }).catch(function (response) {
	          _this4.error = 'Il y a des erreurs sur le formulaire';
	        });
	      } else {
	        this.$http.post('http://ws.ojssymphonique.net/api/concerts?token=' + localStorage.getItem('token'), data).then(function (response) {
	          _this4.$router.push({ name: 'concerts.show', params: { id: response.body.id } });
	        }).catch(function (response) {
	          _this4.error = 'Il y a des erreurs sur le formulaire';
	        });
	      }
	    },
	    addPriceCategory: function addPriceCategory() {
	      this.concert.categories.push(this.categories[this.priceCategory]);
	    },
	    removePriceCategory: function removePriceCategory(i) {
	      this.concert.categories.splice(i, 1);
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 38 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'DashboardIndex',
	  data: function data() {
	    return {
	      'concerts': []
	    };
	  },
	  created: function created() {
	    this.$http.get('http://ws.ojssymphonique.net/api/concerts?token=' + localStorage.getItem('token')).then(function (data) {
	      this.concerts = data.body;
	    });
	  }
	};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(43);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _pdfmake = __webpack_require__(106);
	
	var _pdfmake2 = _interopRequireDefault(_pdfmake);
	
	var _vfs_fonts = __webpack_require__(107);
	
	var _vfs_fonts2 = _interopRequireDefault(_vfs_fonts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DashboardShow',
	  data: function data() {
	    return {
	      concert: {},
	      orders: [],
	      turnover: {},
	      tickets: [],
	      dom: {
	        dropdown: {
	          stock: false,
	          sold: false
	        }
	      }
	    };
	  },
	  created: function created() {
	    var id = this.$route.params.id;
	    this.$http.get('http://ws.ojssymphonique.net/api/concerts/' + id + '?token=' + localStorage.getItem('token')).then(function (data) {
	      this.concert = data.body.concert;
	      this.orders = data.body.orders;
	      this.turnover = data.body.turnover[0];
	      this.tickets = data.body.tickets;
	    });
	  },
	  computed: {
	    stockTotal: function stockTotal() {
	      var stock = 0;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(this.tickets), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var ticket = _step.value;
	
	          stock += parseInt(ticket.stock);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return stock;
	    }
	  },
	  methods: {
	    print: function print() {
	      _pdfmake2.default.vfs = _vfs_fonts2.default.pdfMake.vfs;
	
	      var ticketsSold = [];
	      var ticketsLeft = [];
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(this.tickets), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var ticket = _step2.value;
	
	          ticketsSold.push(ticket.totalTickets + ' au tarif ' + ticket.name);
	          ticketsLeft.push(ticket.stock + ' au tarif ' + ticket.name);
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      var docDefinition = {
	        content: [{
	          text: 'Détail du concert N°' + this.concert.id,
	          style: 'header',
	          fontSize: 25
	        }, {
	          ul: ['Concert : ' + this.concert.name, 'Organisateur : ' + this.concert.organizer, 'Date : ' + this.concert.event_day, 'CA réalisé : ' + this.turnover.total, ['Places restantes : ' + this.stockTotal, {
	            ul: ticketsLeft
	          }], ['Places vendues : ' + this.turnover.sumTickets, {
	            ul: ticketsSold
	          }]],
	          margin: [0, 20]
	        }, {
	          style: 'tableExample',
	          table: {
	            headerRows: 1,
	            body: [[{ text: 'Date', style: 'tableHeader' }, { text: 'N° commande', style: 'tableHeader' }, { text: 'Client', style: 'tableHeader' }, { text: 'Quantités (normal, réduit, groupe)', style: 'tableHeader', colSpan: 3 }, { text: 'Prix normal', style: 'tableHeader' }, { text: 'Prix groupe', style: 'tableHeader' }, { text: 'Envoi', style: 'tableHeader' }, { text: 'Total', style: 'tableHeader' }, { text: 'N° paiement', style: 'tableHeader' }]]
	          }
	        }]
	      };
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = (0, _getIterator3.default)(this.orders), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var order = _step3.value;
	
	          var date = new Date(order.created_at);
	          docDefinition.content[2].table.body.push([date.toLocaleDateString() + ' ' + date.toLocaleTimeString(), order.order_id, order.firstname + ' ' + order.lastname, order.quantity_normal ? order.quantity_normal : 0, order.quantity_reduced ? order.quantity_reduced : 0, order.quantity_group ? order.quantity_group : 0, order.type, order.total, order.payment_id]);
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	
	      _pdfmake2.default.createPdf(docDefinition).download();
	    },
	    exportToCsv: function exportToCsv() {
	      var json2csv = __webpack_require__(98);
	      var fieldNames = ['Date', 'Numéro commande', 'Nom du client', 'Prénom du client', 'Quantité prix normal', 'Quantité prix réduit', 'Quantité prix groupe', 'Mode d\'envoi', 'Total commande', 'Numéro paiement'];
	      var fields = ['created_at', 'order_id', 'lastname', 'firstname', 'quantity_normal', 'quantity_reduced', 'quantity_group', 'type', 'total', 'payment_id'];
	
	      try {
	        var result = json2csv({ data: this.orders, fields: fields, fieldNames: fieldNames });
	        if (!result.match(/^data:text\/csv/i)) {
	          result = 'data:text/csv;charset=utf-8,' + result;
	        }
	        var data = encodeURI(result);
	
	        var link = document.createElement('a');
	
	        link.download = 'export.csv';
	        link.href = data;
	        link.click();
	        $(link).trigger('click');
	      } catch (err) {}
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'DashboardFooter'
	};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'DashboardHeader',
	  data: function data() {
	    return {
	      'firstname': '',
	      'lastname': '',
	      'email': '',
	      'picture': ''
	    };
	  },
	  computed: {
	    fullname: function fullname() {
	      return this.firstname + ' ' + this.lastname;
	    }
	  },
	  methods: {
	    logout: function logout() {
	      this.$store.commit('REMOVE_TOKEN');
	
	      if (window.localStorage) {
	        window.localStorage.removeItem('token');
	      }
	
	      this.$router.push('/login');
	    }
	  },
	  created: function created() {
	    var token = localStorage.getItem('token');
	    this.$http.get('http://ws.ojssymphonique.net/api/user?token=' + token).then(function (data) {
	      this.firstname = data.body.data.firstname;
	      this.lastname = data.body.data.lastname;
	      this.email = data.body.data.email;
	      var gravatar = __webpack_require__(92);
	      this.picture = gravatar.url(this.email);
	    });
	  }
	};

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'DashboardSidebar'
	};

/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 90 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(32)
	
	/* template */
	var __vue_template__ = __webpack_require__(130)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(33)
	
	/* template */
	var __vue_template__ = __webpack_require__(131)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(34)
	
	/* template */
	var __vue_template__ = __webpack_require__(127)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(35)
	
	/* template */
	var __vue_template__ = __webpack_require__(132)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(36)
	
	/* template */
	var __vue_template__ = __webpack_require__(125)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(90)
	
	/* script */
	__vue_exports__ = __webpack_require__(37)
	
	/* template */
	var __vue_template__ = __webpack_require__(128)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(89)
	
	/* script */
	__vue_exports__ = __webpack_require__(38)
	
	/* template */
	var __vue_template__ = __webpack_require__(124)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(39)
	
	/* template */
	var __vue_template__ = __webpack_require__(123)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(40)
	
	/* template */
	var __vue_template__ = __webpack_require__(133)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(41)
	
	/* template */
	var __vue_template__ = __webpack_require__(129)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(42)
	
	/* template */
	var __vue_template__ = __webpack_require__(126)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 123 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n            Détail d'un concert\n        ")]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'dashboard'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-music"
	  }, [_vm._v(" Gestion des concerts")])])], 1), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Détail")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('header', [_c('router-link', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "to": {
	        name: 'concerts.edit',
	        params: {
	          id: _vm.$route.params.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus"
	  }), _vm._v(" Editer le concert\n            ")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Concert N° " + _vm._s(_vm.$route.params.id))])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('section', {
	    attrs: {
	      "id": "event"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Concert : " + _vm._s(_vm.concert.name))]), _vm._v(" "), _c('li', [_vm._v("Organisateur : " + _vm._s(_vm.concert.organizer))]), _vm._v(" "), _c('li', [_vm._v("Date : " + _vm._s(_vm.concert.event_day))])])]), _vm._v(" "), _c('section', {
	    attrs: {
	      "id": "stats"
	    }
	  }, [_vm._m(1), _vm._v(" "), _c('ul', [_c('li', [_vm._v("CA réalisé : " + _vm._s(_vm.turnover.total) + "€")]), _vm._v(" "), _c('li', [_vm._v("\n                            Places vendues : " + _vm._s(_vm.turnover.sumTickets) + "\n                            "), _c('a', {
	    attrs: {
	      "title": "Voir le détail",
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.dom.dropdown.sold = !_vm.dom.dropdown.sold
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus"
	  })]), _vm._v(" "), _c('ul', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.dom.dropdown.sold),
	      expression: "dom.dropdown.sold"
	    }]
	  }, _vm._l((_vm.tickets), function(ticket) {
	    return _c('li', [_vm._v("Tarif " + _vm._s(ticket.name) + " : " + _vm._s(ticket.totalTickets))])
	  }))]), _vm._v(" "), _c('li', [_vm._v("Places restantes : " + _vm._s(_vm.stockTotal) + "\n                            "), _c('a', {
	    attrs: {
	      "title": "Voir le détail",
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.dom.dropdown.stock = !_vm.dom.dropdown.stock
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus"
	  })]), _vm._v(" "), _c('ul', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.dom.dropdown.stock),
	      expression: "dom.dropdown.stock"
	    }]
	  }, _vm._l((_vm.tickets), function(ticket) {
	    return _c('li', [_vm._v("Tarif " + _vm._s(ticket.name) + " : " + _vm._s(ticket.stock))])
	  }))])])]), _vm._v(" "), _c('section', {
	    attrs: {
	      "id": "orders"
	    }
	  }, [_vm._m(2), _vm._v(" "), _c('table', {
	    staticClass: "table table-responsive"
	  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.orders), function(order) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(order.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.order_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.lastname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.firstname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.quantity_normal == null ? 0 : order.quantity_normal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.quantity_reduced == null ? 0 : order.quantity_reduced))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.quantity_group == null ? 0 : order.quantity_group))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.payment_id))])])
	  }))])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('router-link', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "to": {
	        name: 'dashboard'
	      }
	    }
	  }, [_vm._v("\n                    Retour à la liste\n                ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.print($event)
	      }
	    }
	  }, [_vm._v("Imprimer")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.exportToCsv($event)
	      }
	    }
	  }, [_vm._v("Exporter")])], 1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', [_c('h4', [_vm._v("Informations générales du concert")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', [_c('h4', [_vm._v("Statistiques")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', [_c('h4', [_vm._v("Liste des commandes")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Numéro commande")]), _vm._v(" "), _c('th', [_vm._v("Nom du client")]), _vm._v(" "), _c('th', [_vm._v("Prénom du client")]), _vm._v(" "), _c('th', [_vm._v("Quantité prix normal")]), _vm._v(" "), _c('th', [_vm._v("Quantité prix réduit")]), _vm._v(" "), _c('th', [_vm._v("Quantité prix groupe")]), _vm._v(" "), _c('th', [_vm._v("Mode d'envoi")]), _vm._v(" "), _c('th', [_vm._v("Total commande")]), _vm._v(" "), _c('th', [_vm._v("Numéro paiement")])])])
	}]}

/***/ }),
/* 124 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_vm._m(0), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('header', [_c('router-link', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "to": {
	        name: 'concerts.create'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus"
	  }), _vm._v(" Créer un nouveau concert\n            ")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "box-body table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-striped table-bordered"
	  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.concerts), function(concert) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(concert.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(concert.event_day))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(concert.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(concert.address) + ", " + _vm._s(concert.city))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(new Date(concert.event_day).getTime() < new Date().getTime() ? 'OUI' : 'NON'))]), _vm._v(" "), _c('td', [_c('router-link', {
	      attrs: {
	        "to": {
	          name: 'concerts.edit',
	          params: {
	            id: concert.id
	          }
	        }
	      }
	    }, [_vm._v("Editer")]), _vm._v("\n                            /"), _c('router-link', {
	      attrs: {
	        "to": {
	          name: 'concerts.show',
	          params: {
	            id: concert.id
	          }
	        }
	      }
	    }, [_vm._v("Voir")])], 1)])
	  }))])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  })])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n            Administration des concerts\n        ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Liste des concerts")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("N°")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Intitulé")]), _vm._v(" "), _c('th', [_vm._v("Lieu")]), _vm._v(" "), _c('th', [_vm._v("Clôturé O/N ?")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
	}]}

/***/ }),
/* 125 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_vm._m(0), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "error-page"
	  }, [_c('h2', {
	    staticClass: "headline text-yellow"
	  }, [_vm._v(" 404")]), _vm._v(" "), _c('div', {
	    staticClass: "error-content"
	  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v("\n                    We could not find the page you were looking for.\n                    Meanwhile, you may "), _c('router-link', {
	    attrs: {
	      "to": "/dashboard"
	    }
	  }, [_vm._v("return to dashboard")]), _vm._v(" or try using the search form.\n                ")], 1), _vm._v(" "), _vm._m(2)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n            404 Error Page\n        ")]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-dashboard"
	  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Examples")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("404 error")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', [_c('i', {
	    staticClass: "fa fa-warning text-yellow"
	  }), _vm._v(" Oops! Page not found.")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('form', {
	    staticClass: "search-form"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "search",
	      "placeholder": "Search"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-warning btn-flat",
	    attrs: {
	      "type": "submit",
	      "name": "submit"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  })])])])])
	}]}

/***/ }),
/* 126 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('aside', {
	    staticClass: "main-sidebar"
	  }, [_c('section', {
	    staticClass: "sidebar"
	  }, [_c('ul', {
	    staticClass: "sidebar-menu",
	    attrs: {
	      "data-widget": "tree"
	    }
	  }, [_c('li', {
	    staticClass: "header"
	  }, [_vm._v("Menu du Back-Office")]), _vm._v(" "), _c('li', {
	    staticClass: "treeview"
	  }, [_vm._m(0), _vm._v(" "), _c('ul', {
	    staticClass: "treeview-menu"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'dashboard'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-list-ol"
	  }), _vm._v(" Liste des concerts")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'concerts.create'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus"
	  }), _vm._v(" Nouveau concert")])], 1)])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-music"
	  }), _vm._v(" "), _c('span', [_vm._v("Gestion des concerts")]), _vm._v(" "), _c('span', {
	    staticClass: "pull-right-container"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right pull-right"
	  })])])
	}]}

/***/ }),
/* 127 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "login-box"
	  }, [_c('div', {
	    staticClass: "login-logo"
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('b', [_vm._v("Admin")]), _vm._v(" LTE")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "login-box-body"
	  }, [_c('p', {
	    staticClass: "login-box-msg"
	  }, [_vm._v("Connectez-vous")]), _vm._v(" "), _c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.login($event)
	      }
	    }
	  }, [(_vm.error) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('a', {
	    staticClass: "close",
	    attrs: {
	      "data-dismiss": "alert"
	    }
	  }, [_vm._v("×")]), _vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group has-feedback"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.email),
	      expression: "credentials.email"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "email",
	      "placeholder": "Email"
	    },
	    domProps: {
	      "value": (_vm.credentials.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.credentials, "email", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon glyphicon-user form-control-feedback"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group has-feedback"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.password),
	      expression: "credentials.password"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "password",
	      "placeholder": "Mot de passe"
	    },
	    domProps: {
	      "value": (_vm.credentials.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.credentials, "password", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon glyphicon-lock form-control-feedback"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-8"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'register'
	      }
	    }
	  }, [_vm._v("S'inscrire")]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _vm._m(1)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "help-block"
	  }, [_c('a', {
	    attrs: {
	      "href": "http://billetterie-paiement.ojssymphonique.net/password/forget"
	    }
	  }, [_vm._v("Mot de passe oublié ?")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-xs-4"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-block btn-flat",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Connexion")])])
	}]}

/***/ }),
/* 128 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n            Administration des concerts\n        ")]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'dashboard'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-music"
	  }, [_vm._v(" Gestion des concerts")])])], 1), _vm._v(" "), (_vm.$route.params.id) ? _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Modifier")]) : _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Nouveau")])])]), _vm._v(" "), (_vm.error) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('a', {
	    staticClass: "close",
	    attrs: {
	      "data-dismiss": "alert"
	    }
	  }, [_vm._v("×")]), _vm._v("\n        " + _vm._s(_vm.error) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [(_vm.$route.params.id) ? _c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Edition d'un concert")]) : _c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Création d'un concert")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('form', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "id": "new-concert"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.addConcert($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "col-sm-2 control-label",
	    attrs: {
	      "for": "name"
	    }
	  }, [_vm._v("Nom du concert")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-10"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.concert.name),
	      expression: "concert.name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "name",
	      "id": "name"
	    },
	    domProps: {
	      "value": (_vm.concert.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.concert, "name", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "col-sm-2 control-label",
	    attrs: {
	      "for": "organizer"
	    }
	  }, [_vm._v("Organisateur")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-10"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.concert.organizer),
	      expression: "concert.organizer"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "organizer",
	      "id": "organizer"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.concert, "organizer", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.organizers), function(organizer) {
	    return _c('option', {
	      domProps: {
	        "value": organizer.id
	      }
	    }, [_vm._v(_vm._s(organizer.name))])
	  })), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "#",
	      "data-toggle": "modal",
	      "data-target": "#organizer-create-modal"
	    }
	  }, [_vm._v("Créer un nouvel organisateur")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "col-sm-2 control-label",
	    attrs: {
	      "for": "day"
	    }
	  }, [_vm._v("Jour")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.concert.day),
	      expression: "concert.day"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "date",
	      "name": "day",
	      "id": "day"
	    },
	    domProps: {
	      "value": (_vm.concert.day)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.concert, "day", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "col-sm-1 control-label",
	    attrs: {
	      "for": "hour"
	    }
	  }, [_vm._v("Heures")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-2"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.concert.hours),
	      expression: "concert.hours"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "number",
	      "min": "0",
	      "max": "24",
	      "name": "hour",
	      "id": "hour"
	    },
	    domProps: {
	      "value": (_vm.concert.hours)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.concert, "hours", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "col-sm-1 control-label",
	    attrs: {
	      "for": "minutes"
	    }
	  }, [_vm._v("Minutes")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-2"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.concert.minutes),
	      expression: "concert.minutes"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "number",
	      "min": "0",
	      "max": "45",
	      "step": "15",
	      "name": "hour",
	      "id": "minutes"
	    },
	    domProps: {
	      "value": (_vm.concert.minutes)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.concert, "minutes", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "col-sm-2 control-label",
	    attrs: {
	      "for": "place"
	    }
	  }, [_vm._v("Lieu")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-10"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.concert.address),
	      expression: "concert.address"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "place",
	      "id": "place"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.concert, "address", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "0"
	    }
	  }, [_vm._v("Choisissez une adresse")]), _vm._v(" "), _vm._l((_vm.addresses), function(address) {
	    return _c('option', {
	      domProps: {
	        "value": address.id
	      }
	    }, [_vm._v(_vm._s(address.name) + " (" + _vm._s(address.address) + " - " + _vm._s(address.zipcode) + " " + _vm._s(address.city) + ")")])
	  })], 2), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "#",
	      "data-toggle": "modal",
	      "data-target": "#address-create-modal"
	    }
	  }, [_vm._v("Créer une nouvelle adresse ?")])])]), _vm._v(" "), _c('fieldset', {
	    attrs: {
	      "id": "tickets-fields"
	    }
	  }, [_c('legend', [_vm._v("Billets")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "col-sm-2 control-label",
	    attrs: {
	      "for": "price_category"
	    }
	  }, [_vm._v("Ajouter un tarif")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-10"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.priceCategory),
	      expression: "priceCategory"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "price_category"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.priceCategory = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, _vm.addPriceCategory]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "0"
	    }
	  }, [_vm._v("Choisissez un tarif")]), _vm._v(" "), _vm._l((_vm.categories), function(category, index) {
	    return _c('option', {
	      domProps: {
	        "value": index
	      }
	    }, [_vm._v(_vm._s(category.name))])
	  })], 2)])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.concert.categories), function(category, index) {
	    return _c('div', {
	      staticClass: "form-group margin10"
	    }, [_c('label', {
	      staticClass: "control-label col-sm-4"
	    }, [_vm._v(_vm._s(category.name))]), _vm._v(" "), _c('div', {
	      staticClass: "col-sm-3"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (category.amount),
	        expression: "category.amount"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "type": "number",
	        "min": "0.00",
	        "step": "0.01",
	        "placeholder": "Tarif"
	      },
	      domProps: {
	        "value": (category.amount)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(category, "amount", $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "col-sm-3"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (category.quantity),
	        expression: "category.quantity"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "type": "number",
	        "min": "0",
	        "placeholder": "Quantité"
	      },
	      domProps: {
	        "value": (category.quantity)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(category, "quantity", $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "col-sm-2"
	    }, [_c('a', {
	      attrs: {
	        "href": "#",
	        "title": "Retirer"
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.removePriceCategory(index)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-times"
	    })])])])
	  })], 2), _vm._v(" "), _c('fieldset', {
	    staticClass: "checkbox-group required"
	  }, [_c('legend', [_vm._v("Modes d'envoi")]), _vm._v(" "), _vm._l((_vm.modes), function(mode) {
	    return _c('div', {
	      staticClass: "checkbox"
	    }, [_c('label', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.concert.modes),
	        expression: "concert.modes"
	      }],
	      attrs: {
	        "type": "checkbox"
	      },
	      domProps: {
	        "value": mode.id,
	        "checked": Array.isArray(_vm.concert.modes) ? _vm._i(_vm.concert.modes, mode.id) > -1 : (_vm.concert.modes)
	      },
	      on: {
	        "change": function($event) {
	          var $$a = _vm.concert.modes,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = mode.id,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (_vm.concert.modes = $$a.concat([$$v]))
	            } else {
	              $$i > -1 && (_vm.concert.modes = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            _vm.$set(_vm.concert, "modes", $$c)
	          }
	        }
	      }
	    }), _vm._v(" " + _vm._s(mode.type) + "\n                            ")])])
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin10"
	  }, [_c('label', {
	    staticClass: "col-sm-2 control-label",
	    attrs: {
	      "for": "safe-delay"
	    }
	  }, [_vm._v("Délai de sécurité (en heures)")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-10"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.concert.delay),
	      expression: "concert.delay"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "number",
	      "min": "0",
	      "placeholder": "En heures",
	      "name": "name",
	      "id": "safe-delay"
	    },
	    domProps: {
	      "value": (_vm.concert.delay)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.concert, "delay", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "checkbox"
	  }, [_c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.concert.active),
	      expression: "concert.active"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.concert.active) ? _vm._i(_vm.concert.active, null) > -1 : (_vm.concert.active)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.concert.active,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.concert.active = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.concert.active = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.concert, "active", $$c)
	        }
	      }
	    }
	  }), _vm._v(" Concert disponible en ligne\n                        ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin10"
	  }, [(_vm.$route.params.id) ? _c('button', {
	    staticClass: "btn btn-primary"
	  }, [_vm._v("Modifier")]) : _c('button', {
	    staticClass: "btn btn-primary"
	  }, [_vm._v("Créer")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "id": "address-create-modal",
	      "tabindex": "-1",
	      "role": "dialog",
	      "aria-labelledby": "Créer nouvelle adresse"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('form', {
	    attrs: {
	      "method": "post",
	      "action": ""
	    }
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "address-name"
	    }
	  }, [_vm._v("Nom du lieu")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.address.name),
	      expression: "address.name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "address-name",
	      "name": "name"
	    },
	    domProps: {
	      "value": (_vm.address.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.address, "name", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "address"
	    }
	  }, [_vm._v("Adresse")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.address.address),
	      expression: "address.address"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "address",
	      "name": "address"
	    },
	    domProps: {
	      "value": (_vm.address.address)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.address, "address", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "zipcode"
	    }
	  }, [_vm._v("Code postal")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.address.zipcode),
	      expression: "address.zipcode"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "zipcode",
	      "name": "zipcode"
	    },
	    domProps: {
	      "value": (_vm.address.zipcode)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.address, "zipcode", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "city"
	    }
	  }, [_vm._v("Ville")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.address.city),
	      expression: "address.city"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "city",
	      "name": "city"
	    },
	    domProps: {
	      "value": (_vm.address.city)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.address, "city", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "country"
	    }
	  }, [_vm._v("Pays")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.address.country),
	      expression: "address.country"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "country",
	      "name": "country"
	    },
	    domProps: {
	      "value": (_vm.address.country)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.address, "country", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v("Annuler")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.addAddress($event)
	      }
	    }
	  }, [_vm._v("Enregistrer")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "id": "organizer-create-modal",
	      "tabindex": "-1",
	      "role": "dialog",
	      "aria-labelledby": "Créer nouvel organisateur"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('form', {
	    attrs: {
	      "method": "post",
	      "action": ""
	    }
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "organizer-name"
	    }
	  }, [_vm._v("Nom de l'organisateur")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.organizer.name),
	      expression: "organizer.name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "organizer-name",
	      "name": "name"
	    },
	    domProps: {
	      "value": (_vm.organizer.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.organizer, "name", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "legal-form"
	    }
	  }, [_vm._v("Statut")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.organizer.legalForm),
	      expression: "organizer.legalForm"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "legal-form",
	      "name": "legal_form"
	    },
	    domProps: {
	      "value": (_vm.organizer.legalForm)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.organizer, "legalForm", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "siret"
	    }
	  }, [_vm._v("Siret")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.organizer.siret),
	      expression: "organizer.siret"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "siret",
	      "name": "siret"
	    },
	    domProps: {
	      "value": (_vm.organizer.siret)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.organizer, "siret", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "place"
	    }
	  }, [_vm._v("Adresse")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.organizer.address),
	      expression: "organizer.address"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "organizer-place",
	      "id": "organizer_place"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.organizer, "address", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "0"
	    }
	  }, [_vm._v("Choisissez une adresse")]), _vm._v(" "), _vm._l((_vm.addresses), function(address) {
	    return _c('option', {
	      domProps: {
	        "value": address.id
	      }
	    }, [_vm._v(_vm._s(address.name) + " (" + _vm._s(address.address) + " - " + _vm._s(address.zipcode) + " " + _vm._s(address.city) + ")")])
	  })], 2)])])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v("Annuler")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.addOrganizer($event)
	      }
	    }
	  }, [_vm._v("Enregistrer")])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-4"
	  }, [_vm._v("Catégorie")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4"
	  }, [_vm._v("Tarif")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4"
	  }, [_vm._v("Quantité")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v("Ajouter une nouvelle adresse")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v("Ajouter un nouvel organisateur")])])
	}]}

/***/ }),
/* 129 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', {
	    staticClass: "main-header"
	  }, [_c('router-link', {
	    staticClass: "logo",
	    attrs: {
	      "to": {
	        name: 'dashboard'
	      }
	    }
	  }, [_c('span', {
	    staticClass: "logo-mini"
	  }, [_vm._v("OJS")]), _vm._v(" "), _c('span', {
	    staticClass: "logo-lg"
	  }, [_vm._v("OJS")])]), _vm._v(" "), _c('nav', {
	    staticClass: "navbar navbar-static-top"
	  }, [_c('div', {
	    staticClass: "navbar-custom-menu"
	  }, [_c('ul', {
	    staticClass: "nav navbar-nav"
	  }, [_c('li', {
	    staticClass: "dropdown user user-menu"
	  }, [_c('a', {
	    staticClass: "dropdown-toggle",
	    attrs: {
	      "href": "#",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('img', {
	    staticClass: "user-image",
	    attrs: {
	      "src": _vm.picture,
	      "alt": "User Image"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "hidden-xs"
	  }, [_vm._v(_vm._s(_vm.fullname))])]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', {
	    staticClass: "user-header"
	  }, [_c('img', {
	    staticClass: "img-circle",
	    attrs: {
	      "src": _vm.picture,
	      "alt": "User Image"
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.fullname) + "\n                "), _c('small', [_vm._v(_vm._s(_vm.email))])])]), _vm._v(" "), _c('li', {
	    staticClass: "user-footer"
	  }, [_c('div', {
	    staticClass: "pull-right"
	  }, [_c('a', {
	    staticClass: "btn btn-default btn-flat",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.logout($event)
	      }
	    }
	  }, [_vm._v("Déconnexion")])])])])])])])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 130 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "wrapper",
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 131 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('app-header'), _vm._v(" "), _c('app-sidebar'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('app-footer')], 1)
	},staticRenderFns: []}

/***/ }),
/* 132 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "login-box"
	  }, [_c('div', {
	    staticClass: "login-logo"
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('b', [_vm._v("Admin")]), _vm._v(" LTE")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "login-box-body"
	  }, [_c('p', {
	    staticClass: "login-box-msg"
	  }, [_vm._v("Inscrivez-vous")]), _vm._v(" "), _c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.register($event)
	      }
	    }
	  }, [(_vm.errors.length > 0) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('a', {
	    staticClass: "close",
	    attrs: {
	      "data-dismiss": "alert"
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _c('ul', _vm._l((_vm.errors), function(error) {
	    return _c('li', [_vm._v(_vm._s(error.code))])
	  }))]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
	    staticClass: "alert alert-success"
	  }, [_c('a', {
	    staticClass: "close",
	    attrs: {
	      "data-dismiss": "alert"
	    }
	  }, [_vm._v("×")]), _vm._v("\n                " + _vm._s(_vm.success) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group has-feedback"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.email),
	      expression: "credentials.email"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "email",
	      "placeholder": "Email"
	    },
	    domProps: {
	      "value": (_vm.credentials.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.credentials, "email", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon glyphicon-envelope form-control-feedback"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group has-feedback"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.password),
	      expression: "credentials.password"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "password",
	      "placeholder": "Mot de passe"
	    },
	    domProps: {
	      "value": (_vm.credentials.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.credentials, "password", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon glyphicon-lock form-control-feedback"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group has-feedback"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.confirmPassword),
	      expression: "credentials.confirmPassword"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "password",
	      "placeholder": "Confirmer le mot de passe"
	    },
	    domProps: {
	      "value": (_vm.credentials.confirmPassword)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.credentials, "confirmPassword", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon glyphicon-lock form-control-feedback"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group has-feedback"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.firstName),
	      expression: "credentials.firstName"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Prénom"
	    },
	    domProps: {
	      "value": (_vm.credentials.firstName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.credentials, "firstName", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon glyphicon-user form-control-feedback"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group has-feedback"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.lastName),
	      expression: "credentials.lastName"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Nom"
	    },
	    domProps: {
	      "value": (_vm.credentials.lastName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.credentials, "lastName", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon glyphicon-user form-control-feedback"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-8"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'login'
	      }
	    }
	  }, [_vm._v("Connexion")])], 1), _vm._v(" "), _vm._m(0)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-xs-4"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-block btn-flat",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Inscription")])])
	}]}

/***/ }),
/* 133 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('footer', {
	    staticClass: "main-footer"
	  }, [_c('strong', [_vm._v("Copyright © 2018 "), _c('a', {
	    attrs: {
	      "href": "http://www.ojssymphonique.net/fr"
	    }
	  }, [_vm._v("OJS")]), _vm._v(".")]), _vm._v(" Tous droits réservés.\n")])
	}]}

/***/ }),
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.81eeae4bff1d15e9d34e.js